import { Chip, colors, Grid, Tooltip, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import { formatCurrency } from "helpers/utils";

interface Props {
  title: string;
  valor: number;
  inscritos: number;
}

function CardRecGeral({ title, valor, inscritos }: Props): JSX.Element {
  return (
    <Grid item xs={12} md={2} lg={2}>
      <MDBox
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        bgColor="white"
        // bgColor="#344050"
        py={2}
        borderRadius="lg"
        height="150px"
      >
        <Typography
          fontWeight="bold"
          variant="overline"
          color={colors.green[200]}
        >
          {title}
        </Typography>

        <Typography variant="h4" fontWeight="bold" color={colors.green[500]}>
          {formatCurrency(valor)}
        </Typography>
        <MDBox display="flex" justifyContent="flex-end" width="100%" px={1}>
          <Tooltip title="Inscrições" placement="bottom">
            <Chip
              label={inscritos}
              variant="filled"
              color="info"
              sx={{ px: 1, fontSize: 14, fontWeight: "bold" }}
            />
          </Tooltip>
        </MDBox>
      </MDBox>
    </Grid>
  );
}

export default CardRecGeral;
